import { connectHits } from 'instantsearch.js/es/connectors'
import { groupBy } from 'underscore'

import hitSearch from './hitSearch'

let emptyEls = []

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  widgetParams.container.innerHTML = ''

  const tradsLabel = {
    publication: 'Publications',
    news: 'Actualités',
    page: 'Pages',
  }

  widgetParams.container.innerHTML = ''

  if (hits.length !== 0) {
    if (emptyEls.length === 0) {
      emptyEls = hits.slice(0, 3)
    }

    const groupedHits = groupBy(hits, (item) => item.groupType)
    let total = 0

    // hits for each group (publi / news / pages)
    for (const [key, group] of Object.entries(groupedHits)) {
      if (['publication', 'news', 'page'].includes(key)) {
        const html = document.createElement('div')
        html.classList.add('pt-12', 'md:pt-16')

        if (group.length > 5) {
          html.classList.add('pb-10', 'md:pb-0', 'relative')
        }

        total += group.length

        html.innerHTML = `
          <div class="flex justify-between items-center text-white mb-4">
            <p class="font-semibold title--M-bis flex items-center">${tradsLabel[key]} <span class="search-panel__number icon-center ml-4">${group.length}</span></p>

            ${group.length > 5
              ? `<a href="/recherche?query=${widgetParams.searchInstance.renderState[`${config.algolia.env}_pages`].searchBox.query}&type=${key}" class="cta-arrow search-panel__subcta">
                  Voir toutes les ${tradsLabel[key].toLowerCase()}
                  <span class="cta-arrow__circle">
                    <svg width="8" height="8" class="icon--white">
                      <use href="#icon-arrow" xlink:href="#icon-arrow"></use>
                    </svg>
                  </span>
                </a>`
              : ''
            }
          </div>
          <ul>
            ${group.slice(0, 5).map(hit => {
              return `
                <li>
                  ${hitSearch(hit)}
                </li>
              `
            }).join('')
          }
          </ul>
        `

        widgetParams.container.append(html)
      }
    }

    // button see all
    if (total > 0) {
      const button = document.createElement('div')
      button.classList.add('text-center')

      button.innerHTML = `
        <a href="/recherche?query=${widgetParams.searchInstance.renderState[`${config.algolia.env}_pages`].searchBox.query}" class="button button--arrow button--rounded button--orange mt-8 md:mt-12">
          <span class="font-weight-bold">Afficher tous les résultats (${total})</span>
          <svg width="12" height="12" class="icon--white ml-2 flex-shrink-0">
            <use href="#icon-arrow" xlink:href="#icon-arrow"></use>
          </svg>
        </a>
        `
      widgetParams.container.append(button)
    }
  } else {
    const empty = document.createElement('p')
    empty.classList.add('empty')
    empty.innerHTML = `
      <div class="text-center text-white pt-10">
        <svg width="92" height="92" class="mx-auto">
          <use href="#icon-no-results" xlink:href="#icon-no-results"></use>
        </svg>
        <p class="title--M font-semibold mb-4 mt-6 md:mt-10">Pas de résultat pour votre recherche</p>
        <p class="mb-4 md:mb-8 text-base md:text-18 leading-none">Ces sujets peuvent cependant vous intéresser&nbsp;:</p>
      </div>
      <ul>
        ${emptyEls.map(hit => {
          return `
            <li>
              ${hitSearch(hit)}
            </li>
          `
        }).join('')}
      </ul>
    `
    widgetParams.container.append(empty)
  }
}

const customHitsPanel = connectHits(renderHits)

export default customHitsPanel
